import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Blocks routes for users whose role isn't allowed.
 * `allow` is an array of role strings (e.g. ["owner", "admin"]).
 * `menuKey` (optional): if provided, the owner-configured menu permission map
 * is also consulted for admin/kasir users. Owner always has full access.
 */
export default function RoleGuard({ allow, menuKey, children }) {
  const { user, hasMenuAccess } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!allow.includes(user.role)) return <Navigate to="/dashboard" replace />;
  if (menuKey && !hasMenuAccess(menuKey)) return <Navigate to="/dashboard" replace />;
  return children;
}
